<template>
    <div>
        <div style="position: relative">
            <button
                v-if="!readonly"
                class="button red minusIcon"
                @click.prevent="deleteSection"
                type="button"
            >
                <img src="@/assets/minus.svg" />
            </button>

            <div id="dispersionChart" :class="{ fixed: isFullScreen }">
                <ul id="menu">
                    <li>
                        <a @click.prevent="toggleFullScreen" href=""><maximize-icon /></a>
                    </li>
                    <li>
                        <a
                            v-if="shots.length > 0"
                            id="tracer"
                            @click.prevent="toggleAllShots"
                            href=""
                            ><img v-if="!allLinesOn" src="@/assets/tracer-off.svg" /><img
                                v-else
                                src="@/assets/tracer.svg"
                        /></a>
                    </li>
                    <span class="clear"></span>
                </ul>

                <div class="chart" ref="chart" :style="{ height: windowWidth + 'px' }">
                    <img class="hole" src="~@/assets/hole2.svg" />

                    <canvas
                        :ref="'graph_' + graphId"
                        :id="'graph_' + graphId"
                        resize="true"
                        class="canvas"
                    />

                    <div class="shots" ref="shots">
                        <shot-item
                            v-for="(shot, index) in shots"
                            @changeActiveShot="changeActiveShot"
                            :key="index"
                            :index="index"
                            :activeShotIndex="activeShotIndex"
                            :shot="shot"
                            :courseSize="courseSize"
                            :maxSliderValueHorizon="maxSliderValueHorizon"
                            :maxSliderValueVertically="maxSliderValueVertically"
                            :graphId="graphId"
                            :ref="'shot_' + graphId + '_' + index"
                        />
                    </div>

                    <div class="sliders">
                        <input
                            :disabled="readonly"
                            @change="save"
                            value="0"
                            step="1"
                            class="slider horizontal"
                            v-model="horizontalSlider"
                            :max="maxSliderValueHorizon"
                            :min="-maxSliderValueHorizon"
                            type="range"
                        />
                        <input
                            :disabled="readonly"
                            @change="save"
                            value="0"
                            step="1"
                            class="slider vertical"
                            v-model="verticalSlider"
                            :max="maxSliderValueVertically"
                            :min="-maxSliderValueVertically"
                            type="range"
                        />
                    </div>
                </div>

                <span class="yards" v-if="activeShot">
                    <span v-text="getDistanceInfo(horizontalSlider, 'X')"></span>

                    <span class="spacer"></span>
                    <span v-text="getDistanceInfo(verticalSlider, 'Y')"></span>
                </span>

                <p
                    v-if="!readonly && showIntroText"
                    class="introText"
                    v-text="
                        'Use the sliders to position the shots, and the ‘plus’ button to record them'
                    "
                />

                <div class="shotPickerSurround" v-if="!readonly">
                    <ul class="shapeMenu" v-if="shapeMenuOpen">
                        <li><a @click.prevent="chooseShape(1)" href="">Straight right</a></li>
                        <li><a @click.prevent="chooseShape(2)" href="">Curved right</a></li>
                        <li><a @click.prevent="chooseShape(3)" href="">Curved left</a></li>
                    </ul>

                    <div class="shotPickerSelector">
                        <!--<a class="button dark mb30" @click.prevent="shapeMenuOpen = !shapeMenuOpen" href="">
                    <span v-if="shotShap == -1">Pick a shot shape</span>
                    <span v-else-if="shotShap == 1">Straight</span>
                    <span v-if="shotShap == 2">Curved right</span>
                    <span v-if="shotShap == 3">Curved left</span>
                    <img class="arrow" src="@/assets/arrow-right-white-2.svg">
                </a>-->

                        <div class="switchSurround">
                            <span class="item" :class="{ active: !metric }">Feet</span>

                            <span class="item">
                                <label class="switch">
                                    <input type="checkbox" v-model="metric2" @input="save()" />
                                    <span class="slider"></span>
                                </label>
                            </span>

                            <span class="item" :class="{ active: metric }">Inches</span>
                        </div>

                        <a class="button addShot dark" @click.prevent="addShot" href="">
                            <img src="@/assets/arrow-plus-white.svg" />
                        </a>

                        <span class="clear"></span>
                    </div>
                </div>

                <button
                    @click.prevent="removeShot"
                    class="button red"
                    type="button"
                    v-if="activeShotIndex > -1 && !readonly"
                >
                    Delete shot
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ShotItem from "@/components/Pro/Lessons/content/shot-item";
import { MaximizeIcon } from "vue-feather-icons";
import paperjs from "paper";
const paper = paperjs;
export default {
    name: "directional-graph2",
    components: { ShotItem, MaximizeIcon },
    props: {
        readonly: {
            type: Boolean,
            default: false,
        },
        value: {
            required: false,
        },
        record: {
            required: true,
        },
        graphId: {
            required: true,
        },
        metric: {
            required: true,
        },
    },
    created() {
        //If no data exists

        setTimeout(() => {
            if (!this.value) {
                this.addShot();
            } else {
                console.log("setting up shots");
                console.log(this.value);
                this.shots = this.value;

                this.setSliderValue(-this.maxSliderValueHorizon, -this.maxSliderValueVertically);
            }
        }, 1000);
    },
    mounted() {
        window.addEventListener("resize", this.getWindowWidth);
        this.getWindowWidth();

        this.$nextTick(() => {
            this.graphs[this.graphId] = new paper.PaperScope();
            this.graphs[this.graphId].setup("graph_" + this.graphId);
        });
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.getWindowWidth);
    },
    data() {
        return {
            courseSize: 14,
            activeShotIndex: -1,
            isFullScreen: false,
            shapeMenuOpen: false,
            shots: [],
            shotShap: 1,
            horizontalSlider: 0,
            verticalSlider: 0,
            maxSliderValueHorizon: 6,
            maxSliderValueVertically: 8,
            graphs: [],
            paths: [],
            windowWidth: 0,
            allLinesOn: false,
            showIntroText: true,
        };
    },
    watch: {
        horizontalSlider(to) {
            if (this.activeShotIndex > -1) {
                this.shots[this.activeShotIndex].horizon = to;
                this.$nextTick(() => {
                    this.setupDrawing(this.activeShotIndex);
                });
            }

            this.showIntroText = false;
        },
        verticalSlider(to) {
            if (this.activeShotIndex > -1) {
                this.shots[this.activeShotIndex].vertically = to;
                this.$nextTick(() => {
                    this.setupDrawing(this.activeShotIndex);
                });
            }

            this.showIntroText = false;
        },
    },
    computed: {
        activeShot() {
            return this.shots[this.activeShotIndex];
        },
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        metric2: {
            get() {
                return this.metric;
            },
            set(val) {
                this.$emit("metric", val);
            },
        },
        user() {
            return this.$store.state.user;
        },
    },
    methods: {
        deleteSection() {
            this.$emit("sectionDeleted", this.graphId, this.record);
        },
        getWindowWidth() {
            this.windowWidth = this.$refs.chart.offsetWidth;
        },
        addShot() {
            this.shots.push({
                horizon: -this.maxSliderValueHorizon,
                vertically: -this.maxSliderValueVertically,
                type: 1,
            });

            this.shotShap = 1;
            this.activeShotIndex = this.shots.length - 1;
            this.setSliderValue(-this.maxSliderValueHorizon, -this.maxSliderValueVertically);
        },
        removeShot() {
            this.$confirm(
                "Are you sure you want to delete this shot?",
                () => {
                    this.shots.splice(this.activeShotIndex, 1);

                    if (this.paths.length > 0) {
                        this.paths[this.activeShotIndex].remove();
                    }

                    this.activeShotIndex = -1;
                    this.save();
                    this.setSliderValue(
                        -this.maxSliderValueHorizon,
                        -this.maxSliderValueVertically,
                    );
                },
                "yes",
                "No, Cancel",
            );
        },
        save() {
            this.inputVal = this.shots;
            this.$emit("saveChartData2");
        },
        toggleAllShots() {
            if (this.allLinesOn) {
                this.graphs[this.graphId].project.activeLayer.removeChildren();
                this.allLinesOn = false;
                return false;
            }

            this.shots.forEach((item, index) => {
                this.setupDrawing(index, true);
            });

            this.allLinesOn = true;
        },
        changeActiveShot(index) {
            this.activeShotIndex = index;
            this.$nextTick(() => {
                this.setSliderValue(this.activeShot.horizon, this.activeShot.vertically);
                this.shotShap = this.activeShot.type;
            });
        },
        setupDrawing(index, drawAll = false) {
            var shot = this.$refs["shot_" + this.graphId + "_" + index][0].$el;

            const posX = shot.offsetTop + shot.offsetWidth / 2;
            const posY = shot.offsetLeft + shot.offsetWidth / 2;

            if (shot.offsetWidth > 0 || shot.offsetHeight > 0)
                this.drawShot(posY, posX, index, drawAll);
        },
        drawShot(posX, posY, index, drawAll = false) {
            this.graphs[this.graphId].activate();

            if (!drawAll) {
                this.graphs[this.graphId].project.activeLayer.removeChildren();
            }

            const { width, height } = this.graphs[this.graphId].view.size;

            var lineColour = this.user.type == "player" ? "#FFFFFF" : "#267962";

            if (this.shots[index].type == 1) {
                // straight

                this.paths[index] = new paper.Path({
                    segments: [
                        [width / 2, height],
                        [posX, posY],
                    ],
                });

                this.paths[index].strokeColor = lineColour;
                this.paths[index].strokeWidth = 3;
                this.paths[index].dashArray = [1, 3.5];
            }
        },
        toggleFullScreen() {
            this.isFullScreen = !this.isFullScreen;

            this.graphs[this.graphId].project.activeLayer.removeChildren();
            this.paths = [];
            this.activeShotIndex = -1;
            this.$nextTick(() => {
                this.windowWidth = this.$refs.chart.offsetWidth;
                this.graphs[this.graphId].view.viewSize = new paper.Size(
                    this.windowWidth,
                    this.windowWidth,
                );
            });
        },
        chooseShape(shape) {
            this.shotShap = shape;
            this.shapeMenuOpen = false;
            if (this.activeShotIndex > -1) {
                this.shots[this.activeShotIndex].type = shape;
                this.setupDrawing(this.activeShotIndex);
                this.save();
            }
        },
        getDistanceInfo(value, type) {
            var metric = !this.metric ? "feet" : "inches";
            const typeString = type === "X" ? ["left", "right"] : ["short", "long"];
            const sideThrow = value < 0 ? typeString[0] : typeString[1];

            if (!Number(value)) {
                return "0 " + metric;
            }
            return `${Math.abs(value * 1)} ${metric} ${sideThrow}`;
        },
        setSliderValue(x, y) {
            this.horizontalSlider = x;
            this.verticalSlider = y;
        },
    },
};
</script>

<style lang="scss" scoped>
.minusIcon {
    width: 40px;
    height: 40px !important;
    border-radius: 8px !important;
    top: -10px;
    right: 10px;
    position: absolute;
    z-index: 1;
    img {
        position: absolute;
        right: 15px;
        top: 15px;
        width: 9px;
    }
}
#dispersionChart {
    background-image: linear-gradient(to bottom, #15f29f, #0ed392, #15b484, #1f9673, #267962);
    padding: 20px;
    border-radius: 12px;

    margin-bottom: 20px;
    overflow: hidden;
    position: relative;

    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */

    .introText {
        align-items: center;
        background: #60c45c;
        border-radius: 13px;
        display: flex;
        font-size: 14px;
        line-height: 1.5;
        justify-content: center;
        min-height: 64px;
        padding: 10px 20px;
        text-align: center;
        width: 100%;
        margin-top: 10px;
        //z-index: 20;
        z-index: 2;
        color: white;
        margin-bottom: 10px;
    }

    .arrow {
        float: right;
        margin-top: 1px;
    }
    .hole {
        bottom: 47%;
        left: 50%;
        position: absolute;
        transform: translate(-50%, -50%);
        width: 7%;
    }
    #menu {
        li {
            display: inline-block;
            margin-right: 10px;
            float: left;
            a {
                display: block;
                width: 40px;
                height: 40px;
                background: #22b984;
                border-radius: 8px;
                svg {
                    margin-left: 10px;
                    margin-top: 8px;
                    color: white;
                    width: 20px;
                }
            }
        }
    }

    &.fixed {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        border-radius: 0px;
        height: 100%;
        z-index: 41;

        #menu {
            margin-top: env(safe-area-inset-top) !important;
        }
    }

    .shotPickerSelector {
        .button {
            width: calc(100% - 62px);
            float: left;
        }
        .addShot {
            width: 52px;
            height: 52px;
            margin-left: 10px;
            img {
                position: absolute;
                left: 20px;
                top: 19px;
            }
        }
    }

    .chart {
        width: 100%;
        //height:320px;
        position: relative;
        .shots {
            position: absolute;
            //background: blue;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
        }
        .canvas[resize] {
            -webkit-user-drag: none;
            user-select: none;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            position: absolute;
            //background: blue;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
        }
        .sliders {
            position: absolute;
            //background: red;
            width: 100%;
            height: 100%;
            top: 0px;
            //z-index:3;
            //left:0px;
        }
    }
    .yards {
        color: white;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 20px;
        position: relative;
        height: 35px;
        margin-top: 20px;
        .spacer {
            background: #267962;
            height: 110%;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 1px;
            display: block;
        }
    }
    .shotPickerSurround {
        position: relative;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .shapeMenu {
        background-color: #fff;
        border-radius: 13px;
        position: absolute;
        bottom: 10px;
        left: 0;
        margin-top: 10px;
        overflow: hidden;
        padding: 8px;
        position: absolute;
        right: 0;
        z-index: 2;
        width: 215px;
        li {
            cursor: pointer;
            padding-left: 1em;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;

            a {
                display: block;
                color: #267962;
                text-decoration: none;
                padding: 10px;
            }
        }
    }
    .slider {
        width: 100%;
        -webkit-appearance: none;
        bottom: calc(50% - 9px);
        left: 50%;
        margin: 9px 0;
        position: absolute;
        transform: translate(-50%, -50%);
        width: 100%;
        //z-index: 2;
        //background:none;

        &:focus {
            outline: none;
        }

        &::-webkit-slider-runnable-track {
            background: #fff;
            border-radius: 1.3px;
            cursor: pointer;
            height: 0;
            width: 100%;
            z-index: 10;
        }

        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            background: white;
            background: rgb(255, 255, 255);
            background: radial-gradient(
                circle,
                rgba(255, 255, 255, 1) 27%,
                rgba(255, 255, 255, 1) 27%,
                rgba(63, 94, 251, 0) 27%
            );
            border: 0 solid rgba(0, 0, 0, 0);
            border-radius: 50px;
            cursor: pointer;
            height: 45px;
            //padding:10px;
            width: 45px;
            //box-shadow:0px 0px 0px 20px transparent;
            margin: 20px;
            margin-top: -22px;
            //margin-left:-5px;
            &:after {
                content: "";
                position: absolute;
                background: red;
                display: block;
                width: 50px;
                height: 50px;
            }
        }

        &[disabled="disabled"]::-webkit-slider-thumb {
            opacity: 0;
        }

        &::-moz-range-track {
            background: #fff;
            border: 0.2px solid #010101;
            border-radius: 1.3px;
            cursor: pointer;
            height: 2.1px;
            width: 100%;
        }

        &::-moz-range-thumb {
            background: #fff;
            border: 0 solid rgba(0, 0, 0, 0);
            border-radius: 50px;
            cursor: pointer;
            height: 19px;
            width: 19px;
        }

        &::-ms-track {
            background: transparent;
            border-color: transparent;
            border-width: 8.45px 0;
            color: transparent;
            cursor: pointer;
            height: 2.1px;
            width: 100%;
        }

        &::-ms-fill-lower {
            background: #f2f2f2;
            border: 0.2px solid #010101;
            border-radius: 2.6px;
        }

        &::-ms-fill-upper {
            background: #fff;
            border: 0.2px solid #010101;
            border-radius: 2.6px;
        }

        &::-ms-thumb {
            background: #fff;
            border: 0 solid rgba(0, 0, 0, 0);
            border-radius: 50px;
            cursor: pointer;
            height: 19px;
            margin-top: 0;
            width: 19px;
        }

        &:focus::-ms-fill-lower {
            background: #fff;
        }

        &:focus::-ms-fill-upper {
            background: #fff;
        }
        &.horizontal {
            margin-top: 140px;
            margin-left: -20px;

            &:after {
                transform: translateX(20px);
                background: linear-gradient(
                    90deg,
                    #15f29f 0%,
                    #15f29f 42%,
                    rgba(255, 255, 255, 0) 42%,
                    rgba(255, 255, 255, 0) 58%,
                    #15f29f 54%,
                    #15f29f 100%
                );
                content: "";
                height: 1px;
                left: 0;
                position: absolute;
                top: 100%;
                width: 100%;
                z-index: -1;
            }
        }
        &.vertical {
            transform: translate(-50%, 20px) rotate(-90deg);
            left: 50%;
            position: absolute;
            margin-top: 10px;
            &:after {
                transform: translateX(20px);
                background: linear-gradient(
                    90deg,
                    #15f29f 0%,
                    #15f29f 42%,
                    rgba(255, 255, 255, 0) 42%,
                    rgba(255, 255, 255, 0) 58%,
                    #15f29f 54%,
                    #15f29f 100%
                );
                content: "";
                height: 1px;
                left: 0;
                position: absolute;
                top: 100%;
                width: 100%;
                z-index: -1;
            }
        }
    }

    .switchSurround {
        margin-bottom: 20px;
        display: flex;
        width: calc(100% - 62px);
        float: left;
        margin-top: 15px;
        .item {
            flex: 1;
            color: #257961;
            &.active {
                color: white;
            }
        }
    }
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .switch .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #257961;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        height: 52px;
        border-radius: 12px;
        width: 80px;
    }

    .switch .slider:before {
        position: absolute;
        content: "";
        height: 42px;
        width: 42px;
        left: 6px;
        bottom: 5px;
        background-color: #61c45c;
        transition: 0.4s;
        border-radius: 8px;
    }

    .switch input[type="checkbox"]:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }
}
</style>
